<template>
  <div class="achievement-box">
    <div class="land-box land-certificat">
      <!-- <div class="achievement-top">
        <span>证书</span>
      </div>-->
      <a-empty v-if="!loading && certificatList.length == 0" description="您还没有任何证书" />
      <div class="certificat-list">
        <img class="certificat-item" :src="item.url" alt v-for="item in certificatList" @click="certificat = item.url" />
      </div>
    </div>
  </div>
  <showCertificat :certificat="certificat" @closeBox="certificat = null" v-if="certificat"></showCertificat>
</template>

<script>
import showCertificat from "../show-certificat/show-certificat.vue";

export default {
  name: "certificat-list",
  components: {
    showCertificat
  },
  data() {
    return {
      loading: true,
      showAchievement: null,
      certificat: null,

      certificatList: []
    }
  },

  async mounted() {
    this.getStudentRecord();
  },
  methods: {
    //查询学生所有记录
    async getStudentRecord() {
      let res = await this.$api.unifydata.getStudentRecord();
      if (res.statusCode != 200) return this.$message.warning(res.message);
      let list = res.data || [];

      //找到当前班级
      let { platform } = this.$store.state;
      let classList = await this.$api.unifydata.getClassOfUser(platform.Type).then(res => res.data || []);
      let myList = [];
      classList.forEach(item => {
        let myItem = list.find(litem => litem.classId == item.PK_ClassGuid);
        if (myItem) myList.push(myItem);
      });
      //找到证书
      let certificatList = [];
      myList.forEach(item => {
        let certificatItem = item.certificat_list || [];
        certificatList = certificatList.concat(certificatItem);
      })
      this.certificatList = certificatList.filter(item => item.url);

      this.loading = false;
      setTimeout(() => { $('.achievement-item').height($('.achievement-item').width()) }, 100);
    }
  },
}

</script>

<style scoped lang="scss">
@import "./certificat-list.scss";
</style>
